import {
  AppBar,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Input,
  Slider,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";

import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import SEO from /*'../../common/SEO'*/ "../../../src/common/SEO";
import Layout from "../../../src/common/Layout";
const WorkExperience = () => {
  const [clicked, setClicked] = useState(false);
  const [text, setText] = useState(null);
  const [selected, setSelected] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);

  const [yes, setyes] = useState(false);
  const [no, setno] = useState(false);

  const navigate = useNavigate();

  const handleClickYes = () => {
    setyes(true);
    setno(false);
  };

  const handleClickno = () => {
    setno(true);
    setyes(false);
    setOpenDialog(true);
  };

  const handleClick = (e) => {
    if (clicked == false) {
      setSelected(true);
      setClicked(true);
    } else {
      setClicked(false);
      setSelected(false);
    }

    setText(e.target.innerHTML);
    console.log(e.target.innerHTML);
    console.info("You clicked the Chip.");
  };

  const handleClickButton = () => {
    navigate("/englishtest");
  };

  return (
    <>
      <SEO title="CourseSelection" />
      <Layout>
        <div className="edu-course-area edu-section-gap bg-color-white rishabhCSSBackground">
          <div className="container">
            <div className=" grid h-screen place-items-center">
              <div className="flex flex-col h-screen place-items-center justify-center countryPicker">
                <Dialog open={openDialog}>
                  <AppBar position="static" elevation={0}>
                    <Toolbar className="flex w-full">
                      <Typography sx={{color:"white",fontSize:"20px", marginRight:"80%"}}
                      varient="h6" className="font-bold text-24">
                        Change Track
                      </Typography>
                      <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 }}
                        className="absolute top-20 right-0 h-20 w-20 "
                        onClick={() => setOpenDialog(false)}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Toolbar>
                  </AppBar>
                  <DialogContent className="bg-[#FFFFFF]">
                    <div>
                      <Typography className=" text-[#5D3FD3] text-16 font-semibold">
                        You don’t have significant work experience. With your
                        current profile we recommened you to explore other
                        masters programs. You are very likely to see very few
                        universities and courses if you continue with the MBA
                        track.
                      </Typography>
                    </div>
                  </DialogContent>
                  <DialogActions className="bg-[#FFFFFF]">
                    <Button
                      className="mx-5"
                      color="primary"
                      variant="contained"
                      component={Link}
                      to={"/highedulevel"}
                    >
                      Explore Other Master Programs
                    </Button>
                    <Button
                      onClick={() => setOpenDialog(false)}
                      color="primary"
                      variant="contained"
                    >
                      Close
                    </Button>
                  </DialogActions>
                </Dialog>
                <div>
                  <Typography color="secondary"
                    fontSize={28}
                    align="center"
                    className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin">
                    Do you have any work experience?
                  </Typography>
                  <Typography color="light"
                    fontSize={20}
                    align="center"
                     className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin">
                    Having significant work experience increases your options
                    multi fold.
                  </Typography>
                </div>

                <div className="p-20 flex items-center justify-center crad equalMargin">
                <Stack direction="row" spacing={1} className="crad cradFont" style={{fontSize:"50px"}}>
                  <Chip
                  size="large"
                    className="p-20 mx-10 rounded-full font-bold border-3 text-14"
                    sx={{fontSize:"18px", color:"white",m:"50"}}
                    label="Yes"
                    style={{ backgroundColor: yes ? '#603aa2' : '#c59bdb' }}
                    variant={yes ? "filled" : "outlined"}
                    onClick={(e) => handleClickYes(e)}
                  />
                  <Chip
                    className="p-20 rounded-full font-bold border-3 text-14"
                    label="No"
                    size="medium"
                    sx={{fontSize:"18px", color:"white",m:"50"}}
                    style={{ backgroundColor: no ? "#603aa2" : "#c59bdb" }}
                    variant={no ? "filled" : "outlined"}
                    onClick={(e) => handleClickno(e)}
                  />
                  {/* <Chip
            className="p-20 mx-10 rounded-full font-bold border-3 text-14"
            label="PTE"
            size="medium"
            style={{ backgroundColor: pte ? "#00BFFF" : "white" }}
            variant={pte ? "filled" : "outlined"}
            onClick={(e) => handleClickpte(e)}
          />
          <Chip
            className="p-20 rounded-full font-bold border-3 text-14"
            label="Not Planning To Take Any"
            size="medium"
            style={{ backgroundColor: none ? "#00BFFF" : "white" }}
            variant={none ? "filled" : "outlined"}
            onClick={(e) => handleClicknone(e)}
          /> */}
            </Stack>
                </div>

                {yes && (
                  <>
                    <div>
                      <Typography 
                      color="light"
                      fontSize={20}
                      align="center"
                      className="p-20 text-blue font-bold text-20 flex justify-center  text-[#5D3FD3]">
                        How much work experience do you have ?
                      </Typography>
                    </div>

                    <center>
                      <Slider
                        defaultValue={0}
                        aria-label="Default"
                        sx={{
                          width: "50%",
                        }}
                        valueLabelDisplay="auto"
                        size="large"
                        max={60}
                      />
                    </center>
                  </>
                )}

                {/* <div>
                <Typography className='p-20 text-blue font-bold text-20 flex justify-center'>
                What is your expected or gained percentage in {text} ?
                </Typography>
            </div>
            <div className='flex justify-center'>
                <Input type='number'></Input>
            </div> */}
                <div className="d-flex mt-5 justify-center crad">
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    onClick={handleClickButton}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default WorkExperience;
